<template>
    <div class="opp-near-card">
        <div class="flex items-start space-x-4 text-base sm:text-sm">
            <div class="flex-none mt-1">
                <a v-if="guide.imageUrl"
                   :href="url"
                   :alt="guide.topic"
                   :title="guide.topic" class="guide-img-container">
                    <img class="object-cover w-8 rounded-lg shadow-lg"
                         :src="guide.imageUrl"
                         :alt="guide.topic"
                         :title="guide.topic">
                </a>            </div>
            <div class="flex-grow truncate">
                <a class="block font-medium hover:underline" :href="url" :title="guide.topic">
                    <h3 class="">
                        {{ guide.topic }}
                    </h3></a>
                <p class="text-gray-600 truncate">{{ guide.learningModelCategories.join(", ") }}</p>

            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, Ref, ref} from "vue";
import {LearningModuleDtoLightWeight} from "@/dtos";

const props = defineProps({
    guide: {},
})
const guide: LearningModuleDtoLightWeight = props.guide;
const url = `/${guide.id}/${guide.slug}`;

</script>
<style>

</style>